import React, {useState, useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {apiClient} from '../api/ApiClient';
// import jwt_decode from 'jwt-decode'; // Import jwt-decode to decode JWT
import {jwtDecode} from 'jwt-decode';

import './ProfileViewComponent.css'; // Assuming the styles will be similar to Angular version
import './ProfileUpdateComponent.css';

import useZipcodeLookup from './hooks/useZipcodeLookup';

// Importing dropdown options from different profileDropdown files
import {bestArray, eyeArray, educationArray, ethnicityArray, bodyArray, politalArray} from './constants/profileDropdown1';
import {hairArray, relationshipArray, kidsArray, wantKidsArray, eduationArray, religonArray} from './constants/profileDropdown2';
import {livingArray, incomeArray, drinkArray, employmentArray, astroArray, tobaccoArray} from './constants/profileDropdown3';
import {zipcodeCodeCity, zipcodeCodeState, seekingArray, myGenderArray, ageStartArray, heightFeetArray, heightInchArray, jobArray} from './constants/profileDropdown4';

const ProfileUpdateComponent = () => {

    const {zipcodeCity, zipcodeState, zipError, checkZipCode} = useZipcodeLookup();

    // State variables for each field
    const [descHeadline, setDescHeadline] = useState('');
    const [descLookingFor, setDescLookingFor] = useState('');
    const [firstName, setFirstName] = useState('');
    const [memberZipcodeUpdates, setMemberZipcodeUpdates] = useState('');
    const [zipcode, setZipcode] = useState('');
    // const [zipcodeCity, setZipcodeCity] = useState('');
    // const [zipcodeState, setZipcodeState] = useState('');
    // const [zipError, setZipError] = useState('');
    // const {checkZipCode} = useZipcodeLookup();

    // Define states for memberId, passMemberTypeId, passMemberIdViewed

    const [photos, setPhotos] = useState([]);
    const [profile, setProfile] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [fetchError, setFetchError] = useState(null);

    const [user, setUser] = useState(null); // New state for storing decoded JWT user info


    // State for dropdowns
    const [seekingArrayValue, setSeekingArrayValue] = useState('');
    const [myGenderArrayValue, setMyGenderArrayValue] = useState('');

    const [relationshipArrayValue, setRelationshipArrayValue] = useState('');
    const [jobArrayValue, setJobArrayValue] = useState('');
    const [incomeArrayValue, setIncomeArrayValue] = useState('');
    const [educationArrayValue, setEducationArrayValue] = useState('');
    const [employmentArrayValue, setEmploymentArrayValue] = useState('');
    const [bodyArrayValue, setBodyArrayValue] = useState('');
    const [hairArrayValue, setHairArrayValue] = useState('');
    const [eyeArrayValue, setEyeArrayValue] = useState('');
    const [kidsArrayValue, setKidsArrayValue] = useState('');
    const [wantKidsArrayValue, setWantKidsArrayValue] = useState('');
    const [livingArrayValue, setLivingArrayValue] = useState('');
    const [religonArrayValue, setReligonArrayValue] = useState('');
    const [drinkArrayValue, setDrinkArrayValue] = useState('');
    const [bestArrayValue, setBestArrayValue] = useState('');
    const [politalArrayValue, setPolitalArrayValue] = useState('');
    const [tobaccoArrayValue, setTobaccoArrayValue] = useState('');
    const [astroArrayValue, setAstroArrayValue] = useState('');
    const [ethnicityArrayValue, setEthnicityArrayValue] = useState('');

    // Textareas for optional fields
    const [descIntro, setDescIntro] = useState('');
    const [descDate, setDescDate] = useState('');
    const [descHangouts, setDescHangouts] = useState('');
    const [descHobbies, setDescHobbies] = useState('');
    const [descFun, setDescFun] = useState('');
    const [descJob, setDescJob] = useState('');

    // const handleSubmit = (e) => {
        // e.preventDefault();
       // Update profile logic here
    // };


    // Use a separate effect to fetch profile data after token data is fully set
    useEffect(() => {

        // Check if all required values are available before making the API call
            setIsLoading(true); // Start loading

            apiClient.get(`/rest/profile/update`)
                .then(response => {
                    const data = response.data;
                    if (data && data.length > 0) {
                    const profileData = data[0];
                            // Map F/M to Female/Male for the gender dropdown
                    const genderValue = profileData[4] === 'F' ? 'Female' : profileData[4] === 'M' ? 'Male' : '';
                    setMyGenderArrayValue(genderValue);

                    const photosData = data.slice(1);
                    setProfile(profileData);
                    setPhotos(photosData);
                    setIsLoading(false); // End loading
                    // Set each field from profile data to state variables
                    setDescIntro(profileData[3] || '');
                    setFirstName(profileData[5] || '');
                    setSeekingArrayValue(profileData[6] || '');

                    setRelationshipArrayValue(profileData[35] || '');
                    setJobArrayValue(profileData[48] || '');
                    setIncomeArrayValue(profileData[41] || '');
                    setEducationArrayValue(profileData[37] || '');
                    setDescHeadline(profileData[21] || '');
                    
                    setDescLookingFor(profileData[6] || '');
                    setEmploymentArrayValue(profileData[44] || '');

                    setZipcode(profileData[23] || '');
                    
                    setBodyArrayValue(profileData[32] || '');
                    setHairArrayValue(profileData[34] || '');
                    setEyeArrayValue(profileData[33] || '');
                    setKidsArrayValue(profileData[36] || '');
                    setWantKidsArrayValue(profileData[45] || '');
                    setLivingArrayValue(profileData[40] || '');
                    setReligonArrayValue(profileData[38] || '');
                    setDrinkArrayValue(profileData[42] || '');
                    setBestArrayValue(profileData[47] || '');
                    setPolitalArrayValue(profileData[39] || '');
                    setTobaccoArrayValue(profileData[43] || '');
                    setAstroArrayValue(profileData[46] || '');
                    setEthnicityArrayValue(profileData[49] || '');

                    // Set optional fields
                    setDescDate(profileData[18] || '');
                    setDescHangouts(profileData[15] || '');
                    setDescHobbies(profileData[16] || '');
                    setDescFun(profileData[14]|| '');
                    setDescJob(profileData[19] || '');

                    // Set photos and profile
                    setProfile(profileData);
                    setPhotos(photosData);

                    setIsLoading(false);
                }
                setIsLoading(false);
                     // Map data to your state fields
                    // setDescHeadline(profileData[5] || '');
                   //  setFirstName(profileData[5] || ''); // Adjust the index based on actual response
                   //  setZipcode(profileData[25] || '');
                })
                .catch(error => {
                    console.error('Profile fetch error:', error);
                    setFetchError(error);
                    setIsLoading(false); // End loading on error
                });
    }, []); // This effect only runs once all values are set

    if (isLoading) return <div>Loading profile...</div>;
    if (fetchError) return <div>Error loading profile. Please try again later.</div>;

    // Submit handler for profile update


    const handleSubmit = async (e) => {
        e.preventDefault();
    
        // Initialize all profile parameters with 'N'
        const defaultParams = {};
        const allDropdownOptions = [
            ...bodyArray, ...eyeArray, ...hairArray, ...relationshipArray,
            ...jobArray, ...incomeArray, ...educationArray, ...employmentArray,
            ...kidsArray, ...wantKidsArray, ...livingArray, ...religonArray,
            ...drinkArray, ...bestArray, ...politalArray, ...tobaccoArray,
            ...astroArray, ...ethnicityArray
        ];
        
        // Set all possible parameters to 'N' by default
        allDropdownOptions.forEach(option => {
            if (option.code) {
                defaultParams[option.code] = 'N';
            }
        });
    
        // Function to handle setting selected values
        const setSelectedValue = (selectedCode) => {
            if (selectedCode && defaultParams.hasOwnProperty(selectedCode)) {
                defaultParams[selectedCode] = 'Y';
            }
        };
    
        // Set 'Y' for selected dropdowns
        setSelectedValue(bodyArrayValue);
        setSelectedValue(eyeArrayValue);
        setSelectedValue(hairArrayValue);
        setSelectedValue(relationshipArrayValue);
        setSelectedValue(jobArrayValue);
        setSelectedValue(incomeArrayValue);
        setSelectedValue(educationArrayValue);
        setSelectedValue(employmentArrayValue);
        setSelectedValue(kidsArrayValue);
        setSelectedValue(wantKidsArrayValue);
        setSelectedValue(livingArrayValue);
        setSelectedValue(religonArrayValue);
        setSelectedValue(drinkArrayValue);
        setSelectedValue(bestArrayValue);
        setSelectedValue(politalArrayValue);
        setSelectedValue(tobaccoArrayValue);
        setSelectedValue(astroArrayValue);
        setSelectedValue(ethnicityArrayValue);
    
        // Convert the parameters object to array format
        const profileParameters = Object.entries(defaultParams).map(([name, val]) => ({
            name,
            val
        }));
    
        // Add text fields
        const textFields = [
            { name: "MY_GENDER", val: "F" },  // Static gender value
            { name: "desc_headline", val: descHeadline || "" },
            { name: "desc_lookingfor", val: seekingArrayValue || "" },
            { name: "first_name", val: firstName || "" },
            { name: "zipcode_code", val: zipcode || "" },
            { name: "desc_intro", val: descIntro || "" },
            { name: "desc_date", val: descDate || "" },
            { name: "desc_hangouts", val: descHangouts || "" },
            { name: "desc_hobbies", val: descHobbies || "" },
            { name: "desc_fun", val: descFun || "" },
            { name: "desc_job", val: descJob || "" }
        ];
    
        // Create final payload
        const payload = {
            updatedColumns: {
                profile: [...profileParameters, ...textFields]
            }
        };
    
        console.log('Sending payload:', JSON.stringify(payload, null, 2));
    
        try {
            const response = await apiClient.post('/rest/profile/update', payload);
            if (response.status === 200) {
                console.log('Update successful:', response.data);
                alert('Profile updated successfully!');
            } else {
                throw new Error('Update failed');
            }
        } catch (error) {
            console.error('Error updating profile:', error);
            console.error('Error details:', error.response?.data);
            alert('Failed to update profile. Please try again.');
        }
    };
    



    return (
        <form onSubmit={handleSubmit}>
            <div className="container-1024">
                <div id="ProfileDisplay" className="tab-pane">
                    <section className="panel">
                        <div className="panel-body profile-graph-info">
                            <label>My Profile details:</label>
                            <div className="row">

                                <div className="profile-container">
                                    {/* Profile Image */}
                                    <div className="profile-details">
                                        <img
                                            className="profile-img-update"
                                            src={`https://pics.netfixup.com/${photos[0][1]}/${photos[0][0]}`}
                                            alt="Profile"
                                        />
                                    </div>

                                </div>

                            </div>

                            {/* First Name and Zipcode Section */}
                            <div className="row">
                                <div className="form-group col-md-4">
                                    <label>First Name:</label>
                                    <input
                                        maxLength={75}
                                        type="text"
                                        className="form-control"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                        style={{width: '25ch'}}
                                    />
                                </div>
                                <div className="form-group col-md-8">
                                    <label>Zipcode:</label>
                                    <div className="d-flex align-items-center">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={zipcode}
                                            onChange={(e) => setZipcode(e.target.value)}
                                            onBlur={(e) => checkZipCode(e)}
                                            style={{width: '25ch'}}
                                        />
                                        {zipcodeCity && zipcodeState && (
                                            <span className="ms-3">
                                                {zipcodeCity}, {zipcodeState}
                                            </span>
                                        )}
                                        {zipError && (
                                            <span className="ms-3 text-danger">
                                                {zipError}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>


                            {/* Headline */}
                            <div className="row">
                                <div className="form-group">
                                    <label>Headline:</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        minLength="5"
                                        maxLength="200"
                                        value={descHeadline}
                                        onChange={(e) => setDescHeadline(e.target.value)}
                                    />
                                </div>
                            </div>

                            {/* Textareas */}
                            <div className="form-group">
                                <label>Introduction (optional):</label>
                                <textarea
                                    className="form-control"
                                    maxLength="4500"
                                    value={descIntro}
                                    onChange={(e) => setDescIntro(e.target.value)}
                                />
                                <p className="text-right">{4500 - descIntro.length} Char</p>
                            </div>



                            <div className="row">
                                <div className="emailButton">
                                    <span className="quick-view-details-text">{memberZipcodeUpdates}</span>
                                </div>
                            </div>

                            
                            {/* Replace your existing dropdown section with this */}
<div className="form-section">
    <h3 className="form-section-title">Basic Information</h3>
    <div className="dropdown-section">
        <div className="dropdown-column">
            {/* First Column */}
            <div className="dropdown-group">
                <label>My Gender:</label>
                <select value={myGenderArrayValue} onChange={(e) => setMyGenderArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {myGenderArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>

            <div className="dropdown-group">
                <label>Seeking:</label>
                <select value={seekingArrayValue} onChange={(e) => setSeekingArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {seekingArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>

            <div className="dropdown-group">
                <label>Relationship Status:</label>
                <select value={relationshipArrayValue} onChange={(e) => setRelationshipArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {relationshipArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>

            <div className="dropdown-group">
                <label>Education Level:</label>
                <select value={educationArrayValue} onChange={(e) => setEducationArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {educationArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>

            <div className="dropdown-group">
                <label>Employment:</label>
                <select value={employmentArrayValue} onChange={(e) => setEmploymentArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {employmentArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>
            
            <div className="dropdown-group">
                <label>Income Range:</label>
                <select value={incomeArrayValue} onChange={(e) => setIncomeArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {incomeArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>
        </div>

        <div className="dropdown-column">
            {/* Second Column */}
            <div className="dropdown-group">
                <label>Religion:</label>
                <select value={religonArrayValue} onChange={(e) => setReligonArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {religonArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>

            <div className="dropdown-group">
                <label>Political Views:</label>
                <select value={politalArrayValue} onChange={(e) => setPolitalArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {politalArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>

            <div className="dropdown-group">
                <label>Living Situation:</label>
                <select value={livingArrayValue} onChange={(e) => setLivingArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {livingArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>

            <div className="dropdown-group">
                <label>Children:</label>
                <select value={kidsArrayValue} onChange={(e) => setKidsArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {kidsArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>

            <div className="dropdown-group">
                <label>Family Plans:</label>
                <select value={wantKidsArrayValue} onChange={(e) => setWantKidsArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {wantKidsArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    </div>

    <h3 className="form-section-title">Physical Characteristics</h3>
    <div className="dropdown-section">
        <div className="dropdown-column">
            <div className="dropdown-group">
                <label>Body Type:</label>
                <select value={bodyArrayValue} onChange={(e) => setBodyArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {bodyArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>

            <div className="dropdown-group">
                <label>Hair Color:</label>
                <select value={hairArrayValue} onChange={(e) => setHairArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {hairArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>

            <div className="dropdown-group">
                <label>Eye Color:</label>
                <select value={eyeArrayValue} onChange={(e) => setEyeArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {eyeArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>
        </div>

        <div className="dropdown-column">
            <div className="dropdown-group">
                <label>Best Feature:</label>
                <select value={bestArrayValue} onChange={(e) => setBestArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {bestArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>

            <div className="dropdown-group">
                <label>Horoscope:</label>
                <select value={astroArrayValue} onChange={(e) => setAstroArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {astroArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>

            <div className="dropdown-group">
                <label>Tobacco Use:</label>
                <select value={tobaccoArrayValue} onChange={(e) => setTobaccoArrayValue(e.target.value)}>
                    <option value="">[Not selected]</option>
                    {tobaccoArray.map((option) => (
                        <option key={option.id} value={option.code}>
                            {option.detail}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    </div>
</div>
                            
                            
                            
                            
                            
                            
                            
                            
                            
                            
                            

     
                                                   {/* Textareas */}
                       <div className="form-group">
                           <label>First Date (optional):</label>
                           <textarea
                               className="form-control"
                               maxLength="4500"
                               value={descDate}
                               onChange={(e) => setDescDate(e.target.value)}
                           />
                           <p className="text-right">{4500 - descDate.length} Char</p>
                       </div>

                                              {/* Textareas */}
                         <div className="form-group">
                           <label>Hangouts (optional):</label>
                           <textarea
                               className="form-control"
                               maxLength="4500"
                               value={descHangouts}
                               onChange={(e) => setDescHangouts(e.target.value)}
                           />
                           <p className="text-right">{4500 - descHangouts.length} Char</p>
                       </div>

                                              {/* Textareas */}
                       <div className="form-group">
                           <label>Hobbies (optional):</label>
                           <textarea
                               className="form-control"
                               maxLength="4500"
                               value={descHobbies}
                               onChange={(e) => setDescHobbies(e.target.value)}
                           />
                           <p className="text-right">{4500 - descHobbies.length} Char</p>
                       </div>

                                              {/* Textareas */}
                         <div className="form-group">
                           <label>Fun (optional):</label>
                           <textarea
                               className="form-control"
                               maxLength="4500"
                               value={descFun}
                               onChange={(e) => setDescFun(e.target.value)}
                           />
                           <p className="text-right">{4500 - descFun.length} Char</p>
                       </div>

                                              {/* Textareas */}
                          <div className="form-group">
                           <label>Desc Job (optional):</label>
                           <textarea
                               className="form-control"
                               maxLength="4500"
                               value={descJob}
                               onChange={(e) => setDescJob(e.target.value)}
                           />
                           <p className="text-right">{4500 - descJob.length} Char</p>
                       </div>

                            
                            
                            {/* Submit button */}
                            <div style={{textAlign: 'center'}} className="col-lg-12">
                                <br />
                                <button type="submit" className="btn btn-info btn-md">Update Profile</button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </form>
    );
};

export default ProfileUpdateComponent;
